import { assert } from '@varos/util-typescript';
import { SourceContentPropertiesSchema } from './reportSourceSchema';
export function createReportSourceRepository(config) {
    const { repository, client } = config;
    function toSourceObject(collection, content) {
        const parsed = SourceContentPropertiesSchema.parse(content.properties);
        return {
            id: content.id,
            displayName: content.title ?? 'Untitled',
            description: content.description ?? null,
            url: parsed.url ?? null,
            type: content.type ?? 'other',
            scores: collection.properties.flatMap((property) => {
                if (property.type !== 'rating') {
                    return [];
                }
                const value = content.properties[property.key];
                if (typeof value !== 'number') {
                    console.warn('expected number', value);
                    return [];
                }
                return {
                    id: property.key,
                    label: property.display_name,
                    value,
                };
            }),
            original: {
                type: parsed.type ?? 'other',
                publisher: parsed.publisher ?? null,
                publishedAt: parsed.published_at ?? new Date(),
            },
            createdAt: content.created_at,
        };
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'sources', 'find', props.stack],
                async queryFn() {
                    assert(props.stack, 'report source repository currently requires stack');
                    const { data: { 
                    // data: [collection, ...restCollections],
                    data: collections, }, } = await client.user.default.collectionList({
                        limit: 100,
                        stack: props.stack,
                    });
                    // assert(
                    //     collection && restCollections.length === 0,
                    //     'expected exactly one collection in stack'
                    // );
                    const sourceCollection = collections.find((collection) => collection.display_name.toLowerCase().includes('source'));
                    assert(sourceCollection, 'expected source collection in stack');
                    const { data: contents } = await client.user.content.list({
                        collection: sourceCollection.id,
                    });
                    const sources = contents.map((content) => {
                        return toSourceObject(sourceCollection, content);
                    });
                    return sources;
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'sources', 'lookup', props.id],
                async queryFn() {
                    const content = await client.user.content.retrieve(props.id);
                    assert(content.stack, 'report source repository currently requires stack');
                    const { data: { 
                    // data: [collection, ...restCollections],
                    data: collections, }, } = await client.user.default.collectionList({
                        stack: content.stack,
                        limit: 100,
                    });
                    const sourceCollection = collections.find((collection) => collection.display_name.toLowerCase().includes('source'));
                    assert(sourceCollection, 'expected source collection in stack');
                    // assert(
                    //     collection && restCollections.length === 0,
                    //     'expected exactly one collection'
                    // );
                    assert(content.collection == sourceCollection.id, 'expected content');
                    return toSourceObject(sourceCollection, content);
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportSourceRepository.js.map